import actionTypes from 'SRC/modules/redux/actionTypes'

export const setIsMobileDevice = result => ({
  type: actionTypes.SET_IS_MOBILE_DEVICE,
  payload: result
})
